import { Directive, ElementRef, OnInit } from '@angular/core';
import { TourGuideTooltipService } from '../services/tour-guide-tooltip.service';
import { TooltipInjectorService } from '../services/tooltip-injector.service';

@Directive({ selector: '[appTooltip]', standalone: false })
export class AppTooltipDirective implements OnInit {

  constructor(
    private el: ElementRef<HTMLElement>,
    private tooltipService: TourGuideTooltipService,
    private injectorService: TooltipInjectorService
  ) {}

  ngOnInit(): void {
    const tooltipId = this.el.nativeElement.getAttribute('data-tooltip-id');
    if (!tooltipId) return;

    const config = this.tooltipService.getTooltipById(tooltipId);
    if (!config || config.isEnabled === false) return;

    this.injectorService.injectIfMarked(tooltipId);
  }
}
